<div id="content" class="allcp-form" ng-controller="SettingController" ng-init="getSetting()">
    <div ng-include="'modules/company/menus/order_menu.html'"></div>
    <div class="row">
        <div class="col-md-10 col-md-offset-1 white-tab plugin-page">

            <ul class="nav nav-tabs hide-print" id="tabContent">
                <li class="active"><a target="_self" href="#web" data-toggle="tab">Web Uygulama</a></li>
                <!-- <li><a target="_self" href="#mobile" data-toggle="tab">Mobil Ugulama</a></li> -->
                <li><a target="_self" href="#main-page" data-toggle="tab">Ana Sayfa</a></li>
            </ul>
    
            <div class="tab-content">
                <div class="tab-pane active bg-white" id="web">
                    <div class="row">
                        <div class="col-md-12 p50">
                            <div class="radio-custom mb5">
                                <input type="radio" value="1" ng-model="setting.dashboard_map" ng-click="updateSetting(setting)" id="dashboard_map_on">
                                <label for="dashboard_map_on" style="width:100%">
                                    Anasayfada ki map konumumu seç.
                                </label>
                                <p class="text-muted">
                                    <div id="settings-map" style="width:100%;height:250px;"></div>
                                    <hr class="pn m10">
                                    <a href="" ng-click="updateCenter()" class="btn btn-primary">Güncelle</a>
                                </p>
                            </div>
                            
                            <div class="radio-custom mb5">
                                <input type="radio" value="0" ng-model="setting.dashboard_map" ng-click="updateSetting(setting)" id="dashboard_map_off">
                                <label for="dashboard_map_off">
                                    Anasayfada ki mapyı otomatik konumla.
        
                                    <p class="text-muted">
                                        
                                        Eğer bu seçimi yaparsanız takip sayfasında bulunan map otomatik olarak, Şirket Bilgileri içerisinde seçmiş olduğunu konuma odaklanacaktır. Eğer seçimi yapmazsanız; map üzerinde bulunan pinlere göre otomatik olarak şekillenecektir.
                                    </p>
                                </label>
                            </div>
        
                            <div class="checkbox-custom mb5">
                                <input type="checkbox" ng-checked="setting.last_location_time" ng-model="setting.last_location_time" ng-click="updateSetting(setting)" id="last_location_time">
                                <label for="last_location_time">
                                    Son konum saatini göster.
        
                                    <p class="text-muted">
                                        
                                        Eğer bu seçimi yaparsanız takip sayfasında bulunan personel pinlerinizin detaylarında, personellerinizin uygulamarından en son hangi saatte konum alındığı gösterilecektir.
                                    </p>
                                </label>
                            </div>
        
                            <div class="checkbox-custom mb5">
                                <input type="checkbox" ng-checked="setting.remaining_time" ng-model="setting.remaining_time" ng-click="updateSetting(setting)" id="remaining_time">
                                <label for="remaining_time">
                                    Kalan Süreyi Göster
        
                                    <p class="text-muted">
                                        
                                        Eğer bu seçimi yaparsanız takip sayfasında bulunan işler için "KALAN SÜRE" butonu aktif olacaktır.Bu butona tıklayarak bu işe atanmış personel ve iş konumu arasında bulunan tahmini süreyi ve sistemin oluşturacağı tahmini rotayı görebileceksiniz.
                                    </p>
                                </label>
                            </div>
        
                            <div class="checkbox-custom mb5">
                                <input type="checkbox" ng-checked="setting.idle" ng-model="setting.idle" ng-click="updateSetting(setting)" id="idle">
                                <label for="idle">
                                    Bekleme durumunda kilitle / yenile
        
                                    <p class="text-muted">
                                        
                                        Eğer bu seçimi yaparsanız 30 dakika işlem yapılmayan sayfalar işleme kilitlenecektir. Ama seçimi kaldırırsanız zaman aşımı durumunda sayfa yenilecektir.
                                    </p>
                                </label>
                            </div>


                            <div class="checkbox-custom mb5">
                                <input type="checkbox" ng-checked="setting.app_work" ng-model="setting.app_work" ng-click="updateSetting(setting)" id="app_work">
                                <label for="app_work">
                                    İşleri Günlük Göster

                                    <p class="text-muted">
                                        
                                        İşleri günlük göster ön tanımlı olarak gelen ayardır. Eğer bu seçimi yapmazsanız uygulamada ki işler tamamlanma durumuna göre görünecektir.
                                    </p>
                                </label>
                            </div>
                        
                            <div class="checkbox-custom mb5" ng-if="!setting.app_work">
                                <input type="checkbox" ng-checked="setting.show_success_works" ng-model="setting.show_success_works" ng-click="updateSetting(setting)" id="show_success_works">
                                <label for="show_success_works">
                                    Tamamlanmış İşleri Göster

                                    <p class="text-muted">
                                        
                                        Eğer işleri günlük göstermek istemezseniz bu ayar açılır. Bu ayarda tamamlanmış işleri göster veya gizle yapabilirsiniz.
                                    </p>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-pane bg-white" id="mobile">
                    <div class="row">
                        <div class="col-md-12 p50">
                            <div class="checkbox-custom mb5">
                                <input type="checkbox" ng-checked="setting.tracking" ng-model="setting.tracking" ng-click="updateSetting(setting)" id="tracking">
                                <label for="tracking">
                                    Canlı takibi kullan.
                                    <p class="text-muted">
                                        Eğer bu seçimi yaparsanız Teleskop uygulaması kullanan personellerinizi canlı olarak map üzerinden takip edebileceksiniz. Eğer iş süreciniz canlı takibi gerektirmiyorsa bu seçeneği pasif hale getirerek Teleskop uygulaması kullanan personellerinizin şarj kullanımını artırabilirsiniz.
                                    </p>
                                </label>
                            </div>

                            <div class="checkbox-custom mb5">
                                <input type="checkbox" ng-checked="setting.image" ng-model="setting.image" ng-click="updateSetting(setting)" id="image">
                                <label for="image">
                                    Kargoiçi resim modülünü etkinleştir.
                                    <p class="text-muted">
                                        Kargoiçi resim modülünü aktif ederek, çalışanlarınızın mobil uygulama üzerinden cep telefonları ile iş için resim ekleme özelliğini aktif edebilirsiniz. (Bu özellik formlara eklediğiniz resimlerden bağımsız çalışmaktadır.)
                                    </p>
                                </label>
                            </div>

                            <div class="checkbox-custom mb5" ng-if="setting.image">
                                <input type="checkbox" ng-checked="setting.app_local_image" ng-model="setting.app_local_image" ng-click="updateSetting(setting)" id="app_local_image">
                                <label for="app_local_image">
                                    Telefondan resim seçmeye izin ver

                                    <p class="text-muted">
                                        
                                        Telefondan resim seçmeye izin ver özelliğini aktif ederseniz, çalışanlarınızın mobil uygulama üzerinden iş emirlerine cep telefonlarında bulunan resimleri ekleyebileceklerdir.
                                    </p>
                                </label>
                            </div>

                            <div class="checkbox-custom mb5" ng-if="setting.image">
                                <input type="checkbox" ng-checked="setting.app_image_location_info" ng-model="setting.app_image_location_info" ng-click="updateSetting(setting)" id="app_image_location_info">
                                <label for="app_image_location_info">
                                    Çekilen resimlere konum bilgisi ekle

                                    <p class="text-muted">
                                        
                                        Çekilen resimlere konum bilgisi ekle özelliğini aktif ederseniz, çalışanlarınızın mobil uygulama üzerinden iş emirlerine çektiği resimlere konum bilgisi eklenecektir.
                                    </p>
                                </label>
                            </div>

                            <div class="checkbox-custom mb5">
                                <input type="checkbox" ng-checked="setting.barcode_reader" ng-model="setting.barcode_reader" ng-click="updateSetting(setting)" id="barcode_reader">
                                <label for="barcode_reader">
                                    Barkod Okuyucusunu etkinleştir.

                                    <p class="text-muted">
                                        
                                        Barkod okuyucusunu aktif ederek, çalışanlarınızın mobil uygulama üzerinden cep telefonları ile barkod okuma özelliğini aktif edebilirsiniz.
                                    </p>
                                </label>
                            </div>

                            <div class="checkbox-custom mb5">
                                <input type="checkbox" ng-checked="setting.signature" ng-model="setting.signature" ng-click="updateSetting(setting)" id="signature">
                                <label for="signature">
                                    İmza'yı etkinleştir.

                                    <p class="text-muted">
                                        
                                        İmzayı aktif ederek, çalışanlarınızın mobil uygulama üzerinden cep telefonları ile imza alma özelliğini aktif edebilirsiniz.
                                    </p>
                                </label>
                            </div>


                            <div class="checkbox-custom mb5">
                                <input type="checkbox" ng-checked="setting.create_order" ng-model="setting.create_order" ng-click="updateSetting(setting)" id="create_order">
                                <label for="create_order">
                                    Kargo Oluşturmayı Etkinleştir

                                    <p class="text-muted">
                                        
                                        Eğer bu seçeneği seçerseniz, mobil uygulama üzerinden personeller iş oluşturabilirler.    
                                    </p>
                                </label>
                            </div>


                            <div class="checkbox-custom mb5">
                                <input type="checkbox" ng-checked="setting.customer_management_on_company" ng-model="setting.customer_management_on_company" ng-click="updateSetting(setting)" id="customer_management_on_company">
                                <label for="customer_management_on_company">
                                    Müşteri Yönetimini Etkinleştir

                                    <p class="text-muted">
                                        Eğer bu seçeneği seçerseniz, mobil uygulama üzerinden personeller müşteri ekleyebilir, düzenleyebilir ve görüntüleyebilir.    
                                    </p>
                                </label>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="tab-pane bg-white" id="main-page">
                    <div class="row">
                        <div class="col-md-6 p50">

                            <div class="checkbox-custom mb10">
                                <input type="checkbox" ng-checked="order_settings.order_description" ng-model="order_settings.order_description" ng-click="updateOrderSetting(order_settings)" id="order_description">
                                <label for="order_description">
                                    KargoAçıklamasını Göster
                                </label>
                            </div>

                            <div class="checkbox-custom mb10">
                                <input type="checkbox" ng-checked="order_settings.scheduled_time" ng-model="order_settings.scheduled_time" ng-click="updateOrderSetting(order_settings)" id="scheduled_time">
                                <label for="scheduled_time">
                                    KargoSaatini Göster
                                </label>
                            </div>

                            <div class="checkbox-custom mb10">
                                <input type="checkbox" ng-checked="order_settings.order_status" ng-model="order_settings.order_status" ng-click="updateOrderSetting(order_settings)" id="order_status">
                                <label for="order_status">
                                    KargoDurumunu Göster
                                </label>
                            </div>

                            <div class="checkbox-custom mb10">
                                <input type="checkbox" ng-checked="order_settings.order_time" ng-model="order_settings.order_time" ng-click="updateOrderSetting(order_settings)" id="order_time">
                                <label for="order_time">
                                    KargoSüresini Göster
                                </label>
                            </div>

                            <div class="checkbox-custom mb10">
                                <input type="checkbox" ng-checked="order_settings.worker_name" ng-model="order_settings.worker_name" ng-click="updateOrderSetting(order_settings)" id="worker_name">
                                <label for="worker_name">
                                    Personel Adını Göster
                                </label>
                            </div>
    
                            <div class="checkbox-custom mb10">
                                <input type="checkbox" ng-checked="order_settings.customer_info" ng-model="order_settings.customer_info" ng-click="updateOrderSetting(order_settings)" id="customer_info">
                                <label for="customer_info">
                                    Müşteri Bilgilerini Göster
                                </label>
                            </div>
                            
                        </div>
                        <div class="col-md-6 p50">
                            <aside class="nano affix sidebar_left_position"
                                style="width:400px; border:1px solid #a0a0a0;height: auto;">
                                        
                                <div class="p10 mbn pbn">
                                    <p ng-if="order_settings.order_description">
                                        KargoAçıklaması
                                    </p>
                                    <strong class="order-list-time" >
                                        <span ng-if="order_settings.scheduled_time">
                                            {{ moment() | amUtc | amDateFormat:'HH:mm' }} - {{ moment() | amUtc | amDateFormat:'DD MMM YYYY' }}
                                        </span>
                                        <p ng-if="order_settings.order_time">
                                            1 hafta, 2 gün, 2 saat, 3 dakika, 31 saniye
                                        </p>
                                        <span 
                                            style="background-color:#ff9800"
                                            ng-if="order_settings.order_status"
                                            class="order-list-status pull-right">
                                            KargoDurumu
                                        </span>
                                    </strong> 
                                    <strong class="order-list-time clearfix mt5 mb5" ng-if="order_settings.customer_info">
                                        Müşteri Adı
                                    </strong>
                                    <p class="order-list-address mt5" ng-if="order_settings.customer_info">
                                        Müşteri Adresi
                                    </p>
                                </div>
                                <div class="pl10 pr10 pb5">
                                    <p class="order-list-worker" style="font-weight: 600;" ng-if="order_settings.worker_name">
                                        <i class="fa fa-user"></i> 
                                        Personel Adı
                                    </p>
                                    <span class="pull-right" ng-if="order.note_count = 0">
                                        <i class="fa fa-envelope"></i> {{ order.note_count }}
                                    </span> 
                                </div>

                            </aside>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>